/**
 * Swr context configuration
 */

import { SWRConfiguration } from 'swr'
import fetcher from './fetcher.config'

const swrContextConfig: SWRConfiguration = {
  fetcher,
  revalidateOnFocus: false,
  shouldRetryOnError: false
}

export default swrContextConfig
